import React from "react";
import PropTypes from "prop-types";
import styles from "components/common/flash-message.scss";

export const FlashMessage = ({ message, type, onHide }) => {
  if (message === "" || message === null || message === undefined) {
    return null;
  }

  return (
    <div className={ cssClass(type) }>
      { message }
      { delayHide(onHide) }
    </div>
  );
};

FlashMessage.propTypes = {
  message: PropTypes.string,
  onHide: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["success", "error"])
};

FlashMessage.defaultProps = {
  message: null,
  type: "success"
};

const delayHide = (onHide) => {
  setTimeout(() => {
    onHide();
  }, 4000);
  return null;
};

const cssClass = (type) => styles[`container--${type}`];



// WEBPACK FOOTER //
// ./src/js/components/common/flash-message.jsx